import { useSelector } from 'react-redux';
import { CookieConsentPanel, CookieSettingsButton } from '../../components';
import { selectors } from '../../modules/cookies';
import { useAppContext } from '../../pages/App/AppContextProvider';

const CookieConsent = () => {
  const { loggedIn } = useAppContext();
  const isGlobalCookieSettingsIconShown = useSelector(selectors.getIsGlobalCookieSettingsIconShown);

  return (
    <>
      {!loggedIn && isGlobalCookieSettingsIconShown && <CookieSettingsButton floating iconColor="grey.300" />}
      <CookieConsentPanel />
    </>
  );
};

export default CookieConsent;
